// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"224":"register","341":"modals"}[chunkId] + "." + {"224":"057e4fb3","341":"dcda44a4"}[chunkId] + ".css";
};